import { render } from "./defaultMemberPayModel.vue?vue&type=template&id=2623d96c"
import script from "./defaultMemberPayModel.vue?vue&type=script&lang=js"
export * from "./defaultMemberPayModel.vue?vue&type=script&lang=js"

import "./defaultMemberPayModel.vue?vue&type=style&index=0&id=2623d96c&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__